module.exports = __webpack_public_path__ + "static/media/nick.b2ce9830.png";